module.exports = __webpack_public_path__ + "images/77272d4732ba048f7465829ff83dc5a3.png";